import type { CapabilityBinding } from '../../core/types';
import { getCapability } from './registry';
import type { CapabilityDefinition } from './types';

export function buildFormPaths(
  binding: Pick<CapabilityBinding, 'key' | 'pathPrefix' | 'options'>,
  capability?: CapabilityDefinition,
): Record<string, string> {
  const bindingKey = String(binding.key);
  const def = capability ?? getCapability(bindingKey);
  if (!def) {
    throw new Error(`Capability not registered: ${bindingKey}`);
  }
  const prefix = binding.pathPrefix ?? bindingKey;
  if (def.resolvePaths) {
    return def.resolvePaths(prefix, binding.options);
  }
  return def.defaultPaths(prefix);
}
